/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sub_Outside_AssistanceInputs */



/**
* | output |
* | --- |
* | "Outside Assistance" |
*
* @param {Sanction_Sub_Outside_AssistanceInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sub_outside_assistance = /** @type {((inputs?: Sanction_Sub_Outside_AssistanceInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sub_Outside_AssistanceInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Assistance Extérieure")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asistencia Externa")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Assistência Externa")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assistenza Esterna")
	return /** @type {LocalizedString} */ ("Outside Assistance")
});